export default Object.freeze({
    EUR: 0,
    RSD: 1,
    BAM: 2,
})

//THIS ENUM IS DIRECTLY CONNECTED TO CURRENCY ENUM AND IT REPSRESENTS POSITIONS IN ARRAY
